export function toIsoDateLocal(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/**
 * 유료 플랜 시작월(해당 월 1일)부터 **durationMonths**개월분 이용 시,
 * 이용권 **종료일** = 그 구간의 **마지막 날**(시작월로부터 N개월째 달의 말일).
 *
 * 예: 2025-03, 3개월 → 2025년 3·4·5월 구간의 마지막 날 = 2025-05-31.
 */
export function planEndIsoFromStartMonthAndDurationMonths(
  yyyyMm: string,
  durationMonths: number,
): string | null {
  const t = yyyyMm.trim();
  const m = /^(\d{4})-(\d{2})$/.exec(t);
  if (!m) return null;
  const y = Number(m[1]);
  const mo = Number(m[2]);
  if (!Number.isFinite(y) || mo < 1 || mo > 12) return null;
  const n = Math.floor(durationMonths);
  if (!Number.isFinite(n) || n < 1) return null;
  const capped = Math.min(36, n);
  const end = new Date(y, mo - 1 + capped, 0);
  return toIsoDateLocal(end);
}

export function formatKoreanLongDate(isoYmd: string): string {
  const d = new Date(`${isoYmd}T12:00:00`);
  if (Number.isNaN(d.getTime())) return isoYmd;
  return d.toLocaleDateString('ko-KR', { dateStyle: 'long' });
}

export function formatYearMonthKo(yyyyMm: string): string {
  const m = /^(\d{4})-(\d{2})$/.exec(yyyyMm.trim());
  if (!m) return yyyyMm;
  const y = Number(m[1]);
  const mo = Number(m[2]);
  if (!Number.isFinite(y) || mo < 1 || mo > 12) return yyyyMm;
  return new Date(y, mo - 1, 1).toLocaleDateString('ko-KR', { year: 'numeric', month: 'long' });
}
